
import * as d3 from 'd3'
export default {
  methods: {

    draw_Forms() {

      this.canvasForms = this.svg
      .append('g')
      .attr('id', `CANVAS_FROM`)
      .attr('transform', `translate(0.5, 0.5)`)
      .attr('font-family', 'roboto').attr('cursor', 'default')

      // Trion Logo 
      this.canvasForms
      .append('image')
      .attr('xlink:href', this.HOST + '/icon/Logo/JGS_Logo.svg').attr('x', 30).attr('y', 30).attr('width', 230)

      this.canvasForms
      .append('rect')
      .attr('x', -.5).attr('y', this.Canvas.CanvasHeight-10)
      .attr('width', this.Canvas.CanvasWidth).attr('height', 10)
      .attr('fill', '#44A9DF')

      
      // Navigation
      let navi = this.canvasForms
      .append('g')
      .attr('transform', `translate(745, 27)`)

      for(let i=1; i<=15; i++) {

        let item = navi
        .append('g')
        .attr('transform', `translate(${i*25}, 0)`)
        .attr('cursor', 'pointer')
        .on('mouseover', function() {
          d3.select(this).transition().duration(50).select('circle').attr('r', 10)
        })
        .on('mouseout', function() {
          d3.select(this).transition().duration(300).select('circle').attr('r', 7)
        })
        .on('click', () => {
          this.current.svg = i.toString().length == 1 ? 'LC_0' + i : 'LC_' + i
          this.canvasForms.remove()
          this.draw_Forms()
        })
        
        item
        .append('circle')
        .attr('cx', 0).attr('cy', 0).attr('r', 7)
        .attr('fill', i==Number(this.current.svg.substr(3,2)) ? '#F7BACF' : '#E0E0DF').attr('opacity', .5)

        item
        .append('text')
        .attr('transform', `translate(0, ${8*0.35})`)
        .attr('font-size', 8).attr('fill', '#757575')
        .attr('text-anchor', 'middle')
        .text(i)
      }



      // Load SVG File
      this.loadSvg(
        this.canvasForms, {
        x: 0, y: 0,
        url : this.HOST + `/SystemCompletion/LogicCharts/${this.revision}/${this.current.svg}.svg`
        }).then(() => {
          d3.selectAll('text').style('font-family', 'roboto')
          d3.select('#MILESTONE').selectAll('text').attr('font-weight', 500)

          this.chart_ITRs(this.canvasForms)
        }
      )

    

    },
  }
}